<template>
<header class="menu">

    <div class="header" style="width: 100%; margin-top: 1em">

        <div class="row row-mobile">
            <div class="mobile-header-menu">
                <v-col class="search-bar" v-if="isSearch" style="display:flex;">
                    <!-- <v-toolbar dark color="teal"> -->
                    <!-- <v-toolbar-title>State selection</v-toolbar-title> -->

                    <!-- <v-autocomplete clearable v-model="select" :loading="loading" :items="itemsSearch" :search-input.sync="search" cache-items class="mx-4" flat hide-no-data hide-details label="введите поисковый запрос" solo-inverted></v-autocomplete> -->
                    <v-btn icon>
                        <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                    <!-- </v-toolbar> -->
                </v-col>
                <div class="hamburger hamburger--boring" @click="$refs.drov.droverMenu = true" v-if="!isSearch">
                    <div class="hamburger-box">
                        <div class="hamburger-inner"></div>
                    </div>
                </div>

                <div class="header-logo-and-images">
                    <div class="header-logo" v-if="!isSearch">
                        <div class="header-logo__image">
                            <a href="/">
                                <img src="/static/images/logoNewLife.svg" />
                            </a>
                        </div>
                    </div>

                    <div class="header-image-search">
                        <div class="share" v-if="!isSearch">
                            <a href="https://wa.me/+79281771226"  target="_blank" route="ignore">
                                <i  route="ignore" class="fab fa-whatsapp fa-2x" />
                            </a>
                        </div>

                        <div class="header-image__phone" v-if="!isSearch">
                            <a href="tel:89281771226" route="ignore" class="phone-mobile-header"> 8-928-177-12-26 </a>
                        </div>

                    </div>
                </div>
            </div>
        </div>

        <div class="header-items">
            <v-row v-if="isSearch">
                <!-- <div>
                    <div class="header-search-location">
                        <div class="header-search" style="    height: 48px !important;">
                            <div class="header-search__image" @click="isSearch=!isSearch">
                                <img src="/static/images/search.png" />
                            </div>
                        </div>
                    </div>
                </div> -->
                <v-col class="search-bar">
                    <!-- <v-toolbar dark color="teal"> -->
                    <!-- <v-toolbar-title>State selection</v-toolbar-title> -->
                    <v-autocomplete clearable v-model="select" :loading="loading" :items="itemsSearch" :search-input.sync="search" cache-items class="mx-4" flat hide-no-data hide-details label="введите поисковый запрос" solo-inverted></v-autocomplete>
                    <v-btn icon>
                        <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                    <!-- </v-toolbar> -->
                </v-col>
            </v-row>

            <v-row v-if="!isSearch" style="margin-right: 0; margin-left: 0">
                <v-col cols="4">
                    <div class="header-search-location">
                        <!-- <div class="header-search">
                            <div class="header-search__image" @click="isSearch=!isSearch">
                                <img src="/static/images/search.png" />
                            </div>
                        </div> -->
                        <div class="header-location">
                            <div class="header-location__item">
                                <img src="/static/images/geolocation.png" />

                                <v-col cols="6" sm="8">
                                    <!-- tut -->
                                    <v-select v-model="currentCity" v-if="getCityList" :items="getCityList" item-text="name" item-value="domain" @change="changeCity" single-line dense></v-select>
                                    <!-- <v-autocomplete clearable v-model="currentCity" v-if="getCityList" :items="getCityList" @change="changeCity" :search-input.sync="search" cache-items class="mx-4" flat hide-no-data hide-details label="введите поисковый запрос" solo-inverted item-text="name" item-value="domain"></v-autocomplete> -->
                                </v-col>
                            </div>
                        </div>
                    </div>
                </v-col>

                <v-col cols="4">
                    <div class="header-logo">
                        <div class="header-logo__image">
                            <a href="/">
                                <img src="/static/images/logoNewLife.svg" />
                            </a>
                        </div>
                    </div>
                </v-col>
                <v-col cols="4">
                    <div class="header-number">
                        <div class="header-number__item">
                            <div class="header-number__phone">
                                <a route="ignore" href="tel:89281771226">
                                    <img route="ignore" src="/static/images/phone.png" />
                                </a>
                                <div>
                                    <a route="ignore" href="tel:89281771226">
                                        8 928 177 12 26
                                    </a>
                                </div>
                            </div>
                            <div class="header-number-button">
                                <div>
                                    <button class="header-number-button__ring" @click="$refs.mod.dialogСallCons = true">
                                        Заказать звонок
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </v-col>
            </v-row>
        </div>
    </div>

    <nav class="header-bottom-menu">
        <ul class="header-bottom-list">
            <div v-if="getTemplate" v-html="getTemplate.hb8" @click="edit(getTemplate.hb8, 'hb8')" :class="getUser ? 'row isEdit' : 'row'">
            </div>
        </ul>
    </nav>
    <Drower ref="drov" />
    <Modal ref="mod" />
</header>
</template>

<script>
import Drower from "../components/drower";
import Modal from "../components/modal";
import {
    mapGetters
} from "vuex";

export default {
    data: () => ({
        currentCity: {},
        menu: ['Лечение алкоголизма', 'Лечение наркомании'],
        isActive: true,
        isSearch: false,
        // droverMenu: false,
        loading: false,
        itemsSearch: [],
        search: null,
        select: null
    }),
    components: {
        Drower,
        Modal,
    },
    computed: mapGetters(["getTemplate", "getUser", "getCityList", "getHost"]),
    watch: {
        search(val) {
            val && val !== this.select && this.querySelections(val)
        },
        getCityList(val) {
            let host = val.filter(n => n.domain == this.getHost)[0];
            if (host) {
                this.currentCity = host
            } else {
                this.currentCity = val[0]
            }
        },
    },
    methods: {
        querySelections(v) {
            this.loading = true
            // Simulated ajax query
            setTimeout(() => {
                this.itemsSearch = this.states.filter(e => {
                    return (e || '').toLowerCase().indexOf((v || '').toLowerCase()) > -1
                })
                this.loading = false
            }, 500)
        },
        edit(code, block) {
            if (this.getUser) {
                this.$store.commit('setEditor', {
                    code: code,
                    block: block,
                    page: 'template'
                })
            }
        },
        changeCity() {
            window.location.href = 'http://' + this.currentCity;
        }
    },
};
</script>



// WEBPACK FOOTER //
// header.vue?2882df7a